import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import CashoutButton from "./cashout-actions/CashoutButton";
import AutosellButton from "./cashout-actions/AutosellButton";
import CashoutHistoryButton from "./cashout-actions/CashoutHistoryButton";

export default observer(function CashoutActions() {
	const bet = useContext(MyBetsBetContext);

	if (bet.isCashoutUnavailable) {
		return null;
	}

	return (
		<>
			<CashoutButton />
			<AutosellButton />
			<CashoutHistoryButton />
		</>
	);
});
